function listUber(){
    var bt = document.getElementById("list__uber");
    bt.classList.toggle('mostra');
}